String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from './reportWebVitals';
import './index.css';

// NON auth routes served from LoginApp bundle (to avoid loading time)
const LOGIN_ROUTES = [
  "/login",
  "/service-center/login",
  "/fleet-reservation/auth",
  "/office-use/login",
  "/share/",
  "/share-route/",
  "/tracking/task",
  "/ratings-review/",
  "/2fa-approval/",
  "/task_email/review",
  "/maintenance",
  "/subscription-expired",
  "/site-broken",
];

const path = window.location.pathname;

const isLoginRoute =
  path === "/" ||
  LOGIN_ROUTES.some((route) => path.startsWith(route));

if (isLoginRoute) {
  // load LoginApp bundle for public/login routes
  import("./LoginApp").then(({ default: LoginApp }) => {
    ReactDOM.render(
      <React.StrictMode>
        <LoginApp />
      </React.StrictMode>,
      document.getElementById("root")
    );
  });
} else {
  // Load the full App bundle for authenticated routes
  import("./App").then(({ default: App }) => {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById("root")
    );
  });
}
reportWebVitals();